/*
 * Module for the response KB Styles
 */

define([
  "backbone",
  "marionette",
  "messaging/messenger",
  "./responseStylesView",
  "./responseStylesModel",
], function (Backbone, Marionette, Messenger, ResponseStylesView) {
  const ResponseStylesController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "responseStyles";
      this.region = options.region;
      this.visibleDefaultResponseStyles = false;
      this._setUpVents();
    },
    show: async function () {
      const model = Messenger.reqres.request("fetch:kb:responseStyles");
      this.layout = new ResponseStylesView.responseStylesLayout({ model });

      Messenger.onSave(() => {
        model.set("responseStyles", this.layout.getCustomStyles());
        model.saveModel({
          success: function (model) {
            model.dirty = false;
            Messenger.saveAttempted(true);
          },
          error: function (model, response) {
            Messenger.showErrorFromResponse(response);
          },
        });
      });

      const defaultStyles = await this._getDefaultStyles();

      this.layout.on(
        "toggleDefaultResponseStyles",
        function () {
          this.visibleDefaultResponseStyles = !this.visibleDefaultResponseStyles;
          if (this.visibleDefaultResponseStyles) {
            this.layout.showDefaultResponseStyles();
          } else {
            this.layout.hideDefaultResponseStyles();
          }
        },
        this,
      );

      model.onSynced(() => {
        this.showRegion(this.layout);
        this.layout.setDefaultStyles(defaultStyles);
      });
    },
    _getDefaultStyles: async function () {
      const downloadServerUrl = Messenger.reqres.request("get:download:url");
      try {
        return (await fetch(`${downloadServerUrl}responseStyles.css`)).text();
      } catch (e) {
        console.error("Error while loading default styles", e);
      }
      return "";
    },
    _setUpVents: function () {
      //Show the response Styles screen
      Messenger.vent.on(
        "show:kb:profile:responseStyles",
        function () {
          this.show();
        },
        this,
      );

      Messenger.vent.on(
        "refresh:kb:response:styles",
        function (responseStyles) {
          this.customResponseStyles = responseStyles;
          this.show();
        },
        this,
      );
    },
  });

  return ResponseStylesController;
});
